<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,0C12,0,4,0,4,0C3.45,0,3,0.45,3,1C3,1,3,15,3,15C3,15.55,3.45,16,4,16C4,16,12,16,12,16C12.55,16,13,15.55,13,15C13,15,13,1,13,1C13,0.45,12.55,0,12,0C12,0,12,0,12,0ZM8,15C7.45,15,7,14.55,7,14C7,13.45,7.45,13,8,13C8.55,13,9,13.45,9,14C9,14.55,8.55,15,8,15C8,15,8,15,8,15ZM11,12C11,12,5,12,5,12C5,12,5,3,5,3C5,3,11,3,11,3C11,3,11,12,11,12C11,12,11,12,11,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'MobilePhone',
} as DefineComponent
</script>
